import { Controller } from "@hotwired/stimulus"

// The option checkboxes of an integration export card start at the integration's
// configured preset (each box carries it as data-default). This shows a notice
// while the boxes deviate from it, with a link that puts them back.
export default class extends Controller {
  static targets = ["box", "notice"]

  // Also on connect: the browser restores ticked boxes when the page comes back
  // from the history, so the boxes can deviate before anyone touches them.
  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasNoticeTarget) return

    this.noticeTarget.classList.toggle("hidden", !this.deviates())
  }

  reset() {
    this.boxTargets.forEach((box) => {
      box.checked = this.preset(box)
    })
    this.refresh()
  }

  deviates() {
    return this.boxTargets.some((box) => box.checked !== this.preset(box))
  }

  preset(box) {
    return box.dataset.default === "true"
  }
}
